/** @format */

import {useState} from 'react';

import {add} from 'date-fns';

interface Options {
  defaultPeriod?: number;
  now: Date;
}

interface PeriodSelectorLiteReturn {
  startDate: Date;
  endDate: Date;
  onPeriodClick: (key: number) => void;
  currentPeriod: number;
}

const usePeriodSelectorLite = ({defaultPeriod, now}: Options): PeriodSelectorLiteReturn => {
  const [currentPeriod, setCurrentPeriod] = useState<number>(
    defaultPeriod === undefined ? 0 : defaultPeriod,
  );

  const onPeriodClick = (key: number) => {
    setCurrentPeriod(key);
  };

  return {
    endDate: now,
    startDate: add(now, {days: -currentPeriod + 1}),
    onPeriodClick,
    currentPeriod,
  };
};

export {usePeriodSelectorLite};
